import { Col, ColProps, Row } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';

const WidgetContainerComponent: FC<ColProps> = ({
  children,
  className,
  xs,
  md,
  lg,
  xl,
  xxl,
  ...rest
}) => (
  <Row gutter={[16, 16]} className={className}>
    {React.Children.map(children, (child) =>
      child != null ? (
        <Col xs={xs} md={md} lg={lg} xl={xl} xxl={xxl} {...rest}>
          {child}
        </Col>
      ) : null,
    )}
  </Row>
);

export const WidgetContainer = styled(WidgetContainerComponent).attrs({
  className: 'widget-container',
})``;

export const PageContentWrapper = styled.div`
  padding: 0 var(--spacing-06);
  background-color: var(--coolest-gray-10);
  ${WidgetContainer} {
    padding: var(--spacing-06) 0;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: var(--spacing-03);
`;
